import axios from 'axios';
import request from './request';

const upload = async (type, file) => {
  try {
    const { result } = await request.get(
      `/upload?filename=${file.name}&contentType=${file.type}&type=${type}`
    );

    if (result.url && result.key) {
      await axios.put(result.url, file, {
        headers: {
          'Content-Type': file.type,
        },
      });

      return result.key;
    }

    throw new Error('Upload failed');
  } catch (err) {
    console.log(err);
  }
};

export default upload;
